import React from 'react';
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useField } from 'formik';

import getStyles from './styles';

const RadioButton = ({
  name,
  options,
  disabled,
  title,
  layoutHorizontally = false,
  blueTitle = false,
  noError = false,
  ...radioGroupProps
}) => {
  const [field, meta, fieldProps] = useField(name);
  const theme = useTheme();
  const classes = getStyles(theme);

  const handleChange = (e) => {
    fieldProps.setValue(e.target.value);
  };

  return (
    <FormControl component="fieldset" margin="dense">
      {title && (
        <Typography
          sx={{
            ...classes.title,
            ...(blueTitle ? classes.titleBlue : {}),
          }}
        >
          {title}
        </Typography>
      )}
      <RadioGroup
        onChange={handleChange}
        aria-label={field.name}
        value={field.value}
        row={layoutHorizontally}
        sx={layoutHorizontally ? classes.horizontallyMarginTop : undefined}
        {...field}
        {...radioGroupProps}
      >
        {options.map((option, index) => {
          const { label: lab, value } = option;

          return (
            <FormControlLabel
              data-testid={`${name}-${value}`}
              key={`${name}-radio-${index}`}
              id={`${name}-radio-${index}`}
              value={value}
              control={
                <Radio
                  color="secondary"
                  key={`${index}-radio-${name}`}
                  sx={
                    !layoutHorizontally
                      ? classes.radioVerticalRoot
                      : index > 0
                        ? classes.radioMarginLeft
                        : undefined
                  }
                />
              }
              label={lab}
              disabled={disabled}
              sx={{ '& .MuiFormControlLabel-label': classes.titleRadio }}
            />
          );
        })}
      </RadioGroup>
      {meta?.touched && meta?.error && !noError && (
        <FormHelperText error>{meta?.error}</FormHelperText>
      )}
    </FormControl>
  );
};

export default RadioButton;
